export default "__VITE_ASSET__B$K_yeb8__"